<!-- 分红送配 -->
<template>
  <div v-if="!$isEmpty(bonusList)" class="fund-bonus">
    <div class="top-title row" @click="goDetails">
      <div class="title-text">分红送配</div>
      <img :src="RIGHT_ARROW" class="arrow"/>
    </div>
    <div class="content row">
      <div v-for="(item, index) in bonusList" :key="index" class="content-item">
        <div class="item-name">{{item.name}}</div>
        <div class="item-value">{{item.value}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'fund-bonus',

  props: {
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
    };
  },

  computed: {
    bonusList() {
      return this.detailInfo?.bonusDetailData || [];
    },
  },

  methods: {
    goDetails() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.fhsp.click', '');
      this.$goFundApp();
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.fund-bonus {
  width: 100%;
  background-color: #ffffff;
  margin-top: 24px;
  box-sizing: border-box;
  padding: 40px 24px;
  border-radius: 12px;
  .top-title {
    .title-text {
      font-size: 32px;
      color: #000000;
      font-weight: bold;
    }
    .arrow {
      width: 32px;
      height: 32px;
      margin-left: 8px;
    }
  }
  .content {
    margin-top: 36px;
    justify-content: space-between;
    .content-item {
      text-align: center;
      .item-name {
        font-size: 28px;
        color: #999999;
      }
      .item-value {
        margin-top: 16px;
        font-family: DINAlternate-Bold;
        font-size: 32px;
        color: #000000;
      }
    }
    .content-item:first-child {
      text-align: left;
    }
    .content-item:last-child {
      text-align: right;
    }
  }
}
</style>
